import styled from 'styled-components';
function getPosition(tabPanelPosition) {
    if (tabPanelPosition === 'top') {
        return 'column-reverse';
    }
    if (tabPanelPosition === 'right') {
        return 'row';
    }
    if (tabPanelPosition === 'left') {
        return 'row-reverse';
    }
    return 'column';
}
export const TabsWrapper = styled.div `
  width: 100%;
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}px;` : '')}
  display: flex;
  flex-direction: ${({ tabPanelPosition }) => getPosition(tabPanelPosition)};
`;
